if (!customElements.get('cart-drawer-upsell')) {
  customElements.define(
    'cart-drawer-upsell',
    class CartDrawerUpsell extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.onClick.bind(this));
        if (this.dataset.loaded === 'true' || !this.dataset.url) return;
        this.dataset.loaded = 'true';
        this.load(this.dataset.url, this.dataset.fallbackUrl);
      }

      load(url, fallbackUrl) {
        fetch(url)
          .then((response) => response.text())
          .then((text) => {
            const inner = new DOMParser().parseFromString(text, 'text/html').querySelector('.cart-upsell__inner');
            if (inner) {
              this.innerHTML = inner.outerHTML;
            } else if (fallbackUrl) {
              this.load(fallbackUrl);
            } else {
              this.hidden = true;
            }
          })
          .catch((error) => {
            console.error('[cart-drawer-upsell]', error);
            if (fallbackUrl) {
              this.load(fallbackUrl);
            } else {
              this.hidden = true;
            }
          });
      }

      onClick(event) {
        const button = event.target.closest('.cart-upsell__add');
        if (!button || button.disabled || button.classList.contains('loading')) return;
        event.preventDefault();
        this.add(button);
      }

      add(button) {
        const variantId = button.dataset.variantId;
        if (!variantId) return;

        const cartDrawer = document.querySelector('cart-drawer');
        const spinner = button.querySelector('.loading__spinner');
        button.classList.add('loading');
        button.setAttribute('aria-disabled', 'true');
        if (spinner) spinner.classList.remove('hidden');
        if (cartDrawer) cartDrawer.setActiveElement(document.activeElement);

        const sections = cartDrawer ? cartDrawer.getSectionsToRender().map((section) => section.id) : [];
        const body = JSON.stringify({
          id: variantId,
          quantity: 1,
          sections: sections,
          sections_url: window.location.pathname,
        });
        const addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

        fetch(addUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
          body: body,
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.status) {
              console.error('[cart-drawer-upsell] add error', data);
              return;
            }
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-drawer-upsell', cartData: data });
            }
            if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
              cartDrawer.renderContents(data);
            }
          })
          .catch((error) => {
            console.error('[cart-drawer-upsell]', error);
            button.classList.remove('loading');
            button.removeAttribute('aria-disabled');
            if (spinner) spinner.classList.add('hidden');
          });
      }
    }
  );
}